import { Component, OnInit, Input, Inject } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MAT_BOTTOM_SHEET_DATA } from "@angular/material";

@Component({
  selector: "app-information-sheet",
  templateUrl: "./information-sheet.component.html",
  styleUrls: ["./information-sheet.component.css"]
})
export class InformationSheetComponent implements OnInit {
  private _message: string = "";

  @Input()
  public set message(message: string) {
    this._message = (message && message.trim()) || "";
  }

  public get message(): string {
    return this._message;
  }
  constructor(private bottomSheet: MatBottomSheet, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
    this.message = data.message;
  }

  ngOnInit() {}
}
